var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_vm._t("default"),(_vm.showDelete)?_c('TableHeaderCell',{staticStyle:{"width":"6.5rem"}}):_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }